import Success from "components/success/index";
import Authentication from "containers/AuthenticationPage/index";
import CreatePassword from "containers/createpassword/index";
import VerifyOtp from "containers/OtpScreen/index";
import SecurityQuestions from "containers/SignUpContainer/securityQuestions/securityQuestion";
import VerifyCode from "containers/verifyCode/index";
import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

// for invited user
const CreatePasswordContainer = ({ invite }) => {
  const [step, setStep] = useState(1);
  const nextStep = () => setStep(step + 1);
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const token = searchParams.get("token");
  const isReset = searchParams.get("password_reset", false);
  const [selectedQuestions, setSelectedQuestions] = useState(["", "", ""]);
  const [answers, setAnswers] = useState(["", "", ""]);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");

  if (!email || !token) {
    return <div>Invalid link. Please check your email.</div>;
  }


  const [userData, setUserData] = useState({ email: "", name: "" });
  const [signinSuccess, setSigninSuccess] = useState(false);
  const navigate = useNavigate();
  const signinHandler = () => {
    // Force password sign-in shortly after invite completion (time-bound)
    const ttlMs = 5 * 60 * 1000; // 5 minutes
    const expiresAt = Date.now() + ttlMs;
    localStorage.setItem("forcePasswordSignInUntil", String(expiresAt));
    // Backward compat: remove legacy flag if exists
    localStorage.removeItem("forcePasswordSignIn");
    localStorage.removeItem("izauthtoken");
    navigate("/signin");
    window.location.reload(); 
  };
  return (
    <>
      {(isReset ? step === 1 : step === 2) && (
        <SecurityQuestions
          nextStep={nextStep}
          askQuestions={!isReset}
          selectedQuestions={selectedQuestions}
          setSelectedQuestions={setSelectedQuestions}
          answers={answers}
          setAnswers={setAnswers}
          setAnswer={setAnswer}
          setQuestion={setQuestion}
          question={question}
          answer={answer}
        />
      )}

      {(isReset ? step === 2 : step === 1) && (
        <CreatePassword
          isReset={isReset}
          nextStep={nextStep}
          token={token}
          email={email}
          setUserData={setUserData}
          setSelectedQuestions={setSelectedQuestions}
          setAnswers={setAnswers}
          selectedQuestions={selectedQuestions}
          question={question}
          answer={answer}
          answers={answers}
        />
      )}
      
      {step === 3 && <Authentication nextStep={nextStep} userData={userData} />}
      {step == 4 && !isReset && (
        <VerifyOtp
          userData={userData}
          invite={true}
          setSigninSuccess={setSigninSuccess}
          setStep={setStep}
          selectedQuestions={selectedQuestions}
          answers={answers}
        />
      )}
      {step == 4 && isReset && (
        <VerifyCode
          signin={true}
          nextStep={nextStep}
          isReset={true}
          setStep={setStep}
          checkAuth={true}
          setSigninSuccess={setSigninSuccess}
        />
      )}
      {step === "" && !isReset && signinSuccess && (
        <Success
          success={true}
          title="Account Created Successfully"
          subTitle="Your account has been successfully signed up. Enjoy exploring our services!"
          buttonText="Sign in"
          onClick={signinHandler}
        />
      )}
      {step === "" && isReset && signinSuccess && (
        <Success
          success={true}
          title="Password Reset Successful"
          subTitle="Your account has been successfully restored"
          buttonText="Sign in"
          onClick={signinHandler}
        />
      )}
    </>
  );
};

export default CreatePasswordContainer;